import CardModalDescription from './CardModalDescription';

export default CardModalDescription;
